import React, { useCallback, useEffect, useState } from "react";
import { useBuyCart } from "@/Hooks/BuyCart/useBuyCart";
import { createContext, useContext } from "react";
import type { MFormMethodPayment } from "@/Models/MUser/MFormMethodPayment";
import type { MBasket } from "@/Models/MBuyPropduct/BuyProduct";
import type { ProductByIdPdp } from "@/Models/MPDP/ProductByIdPDP";
import { getIpCliente } from "@/Service/Api/Index";
import { useTicketCart } from "@/Hooks/TicketCart/useTicketCart";
import type { products } from "@/Models/MProduct/Products";
import type { MBasketBuy } from "@/Models/MBasketBuy/MBasketBuy";
import type { MBuyFrom } from "@/Models/MBuyFrom/MBuyFrom";
import type { MBuyCarCheckout } from "@/Models/MBuyCarCheckout/MBuyCarCheckout";

type TicketContexType = {
  SendBuyCartV2: (
    idSkus: string[],
    Country: string,
    City: string,
    ZipCode: number,
    Cupon: string
  ) => void;
  PaymentMehted: (typePayment: string) => void;
  formUserData: MFormMethodPayment;
  AddTicketCart: (
    productos: ProductByIdPdp,
    Quantity: number,
    Ipx: string
  ) => void;
  AddPlpTciektCart: (mDatos: products[]) => void;
  UpdateQuantity: (IdSKU: string, quantity: number) => void;
  DeleteTicketCart: (sku: string) => void;
  //CodeBarra: OrderBuyResponse[];
  //SaveCodeBarra: (ScodeBarra: OrderBuyResponse[]) => void;
  ResponseBasket: MBasketBuy;
  SaveResponseBasket: (responsesBasket: MBasketBuy) => void;
  MBasketMFormData: MBuyFrom;
  SaveMBasketMFormData: (MBasketMFormDatas: MBuyFrom) => void;
  formDataClient: MBuyCarCheckout;
  SaveDataClient: (dataClient: MBuyCarCheckout) => void;
  ClearDeleteTicket: () => void;
};

const TicketContext = createContext<TicketContexType | undefined>(undefined);

const STORAGE_KEY = "TicketPrintCache";

export const ContextTicketCartProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { SendBuyCartV2 } = useBuyCart();
  const { AddTicketCartGo, UpdateQuantity, DeleteTicketCart } = useTicketCart();
  const [formUserData, setFormUserData] = useState<MFormMethodPayment>({
    TypePayment: "",
  });
  //const [CodeBarra, setCodeBarra] = useState<OrderBuyResponse[]>([]);
  const [formDataClient, SetFormDataClient] = useState<MBuyCarCheckout>({
    postalCode: "",
    cColonia: "",
    address1: "",
    cStreetNumber: "",
    interNumber: "",
    reference: "",
    city: "",
    stateCode: "",
    firstName: "",
    phone: "",
    //no estan en el formulario
    countryCode: "", //MX mexico
    companyName: "", //
    fullName: "",
    lastName: "",
    //basketId del back-end
    id: "",
    //Importantes
    ipAddress: "",
    priceSale: 0, //totalSalesPrice ?? 0,
    Quantity: 0, //quant ?? 0,
    email: "",
  });

  const [ResponseBasket, setResponseBasket] = useState<MBasketBuy>({
    basketId: "",
    customerInfo: {
      customerId: "",
    },
  });

  const [MBasketMFormData, setMBasketMFormData] = useState<MBuyFrom>(
    () => {
      //ESTADO INICIAL DESDE LOCALSTORAGE
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored
        ? JSON.parse(stored)
        : {
            dataPdp: {
              skuId: "",
              productItems: [],
            },
            formData: formDataClient,
          };
    }

    //   {
    //   dataPdp: {
    //     skuId: "",
    //     productItems: [],
    //   },
    //   formData: formDataClient,
    // }
  );

  const PaymentMehted = useCallback(
    (typePayment: string) => {
      setFormUserData({
        TypePayment: typePayment,
      });
    },
    [formUserData]
  );

  //agregamos al listado de productos para el ticket
  const AddTicketCart = useCallback(
    (productos: ProductByIdPdp, Quantity: number, Ipx: string) => {
      const newTicketProducts: MBasket = {
        base_price: Number(productos?.ListPrice) ?? 0,
        cBarcode: productos?.Ean ?? "",
        c_conversionFactor: productos?.CConversionFactor ?? 0,
        c_fromStoreId: "",
        c_selectedUnit: productos?.Unit ?? "",
        c_selesUnit: productos?.CSalesUnit ?? "",
        cIsDigital: productos?.IsDigital ?? false,
        cSaleLimit: productos?.CSaleLimit ?? 0,
        cCategoryId: productos?.CCategory ?? "",
        cBadges: productos?.CBadges != null ? productos?.CBadges : "",
        cMinOrderQuantity: productos?.MinOrderQuantity ?? 0,
        inventoryId: "",
        item_id: productos?.Id ?? "",
        price: productos?.Price ?? 0, //cSalesPrice
        productId: productos?.Id ?? "",
        productName: productos?.Name?.toLowerCase() ?? "",
        quantity: Number(Quantity) ?? 0,
        stepQuantity: productos?.StepQuantity ?? 0,
        isDigital: productos?.IsDigital ?? false,
        sellLimit: productos?.CSaleLimit ?? 0,
        pricePromotion: 10, //xDefecto
        //se agrega la ip del cliente
        ipAddress: Ipx ?? "",
        listPrice: Number(productos?.ListPrice) ?? 0,
        salePrice: Number(productos?.SalesPrice) ?? 0,
      };
      //agregamos al carrito de tickets
      AddTicketCartGo(newTicketProducts);
    },
    []
  );

  const AddPlpTciektCart = useCallback(async (mDatos: products[]) => {
    const ipClient = await getIpCliente();
    const newTicketProducts: MBasket = {
      base_price: Number(mDatos[0]?.ListPrice) ?? 0,
      cBarcode: mDatos[0]?.Ean ?? "",
      c_conversionFactor: mDatos[0]?.CConversionFactor ?? 0,
      c_fromStoreId: "",
      c_selectedUnit: mDatos[0]?.Unit ?? "",
      c_selesUnit: mDatos[0]?.CSalesUnit ?? "",
      cIsDigital: mDatos[0]?.IsDigital ?? false,
      cSaleLimit: mDatos[0]?.CSaleLimit ?? 0,
      cCategoryId: mDatos[0]?.CCategory ?? "",
      cBadges: mDatos[0]?.CBadges != null ? mDatos[0]?.CBadges : "",
      cMinOrderQuantity: mDatos[0]?.MinOrderQuantity ?? 0,
      inventoryId: "",
      item_id: mDatos[0]?.Id ?? "",
      price: mDatos[0]?.Price ?? 0, //cSalesPrice
      productId: mDatos[0]?.Id ?? "",
      productName: mDatos[0]?.Name?.toLowerCase() ?? "",
      quantity: 1,
      stepQuantity: mDatos[0]?.StepQuantity ?? 0,
      isDigital: mDatos[0]?.IsDigital ?? false,
      sellLimit: mDatos[0]?.CSaleLimit ?? 0,
      pricePromotion: 10, //xDefecto
      //se agrega la ip del cliente
      ipAddress: String(ipClient) ?? "",
      listPrice: Number(mDatos[0]?.ListPrice) ?? 0,
      salePrice: Number(mDatos[0]?.SalesPrice) ?? 0,
    };
    //agregamos al carrito de tickets
    AddTicketCartGo(newTicketProducts);
  }, []);

  const SaveResponseBasket = useCallback((responsesBasket: MBasketBuy) => {
    setResponseBasket(responsesBasket);
  }, []);

  // const SaveCodeBarra = useCallback((ScodeBarra: OrderBuyResponse[]) => {
  //   setCodeBarra(ScodeBarra);
  // }, []);

  const SaveMBasketMFormData = useCallback((MBasketMFormDatas: MBuyFrom) => {
    setMBasketMFormData(MBasketMFormDatas);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(MBasketMFormDatas));
  }, []);

  const SaveDataClient = useCallback((dataClient: MBuyCarCheckout) => {
    SetFormDataClient(dataClient);
  }, []);

  const ClearDeleteTicket = useCallback(() => {
    setMBasketMFormData({
      dataPdp: {
        skuId: "",
        productItems: [],
      },
      formData: formDataClient,
    });
    localStorage.removeItem(STORAGE_KEY);
  }, [MBasketMFormData]);

  useEffect(() => {
    //guardamos en el localstorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(MBasketMFormData));
  }, [MBasketMFormData]);

  return (
    <TicketContext.Provider
      value={{
        SendBuyCartV2,
        PaymentMehted,
        formUserData,
        AddTicketCart,
        AddPlpTciektCart,
        UpdateQuantity,
        DeleteTicketCart,
        // CodeBarra,
        // SaveCodeBarra,
        ResponseBasket,
        SaveResponseBasket,
        MBasketMFormData,
        SaveMBasketMFormData,
        formDataClient,
        SaveDataClient,
        ClearDeleteTicket,
      }}>
      {children}
    </TicketContext.Provider>
  );
};

export const useContextTicketProvider = () => {
  const context = useContext(TicketContext);
  if (!context) {
    throw new Error(
      "useContextTicketProvider must be used within a  ContextTicketCartProvider"
    );
  }
  return context;
};
